/**
 * User related constants
 */

/**
 * User session state
 */
const LoginState = {
    PENDING: 'pending',
    ANONYMOUS: 'anonymous',
    ACCOUNT: 'user'
};

export {LoginState};
